module.exports = __webpack_public_path__ + "media/courses/apply/images/email-sent-icon-4655323c03c48b8630759c8544bf7969.svg";